import { connect } from '@formily/react-schema-renderer';
import moment from 'moment';
import { TimePicker as AntdTimePicker } from 'antd';
import { mapStyledProps, mapTextComponent, compose, isStr, isArr, } from '../shared';
var transformMoment = function (value) {
    if (value === '')
        return undefined;
    return value;
};
var mapMomentValue = function (props, fieldProps) {
    var value = props.value;
    if (!fieldProps.editable)
        return props;
    try {
        if (isStr(value) && value) {
            props.value = moment(value, 'HH:mm:ss');
        }
        else if (isArr(value) && value.length) {
            props.value = value.map(function (item) { return (item && moment(item, 'HH:mm:ss')) || ''; });
        }
    }
    catch (e) {
        throw new Error(e);
    }
    return props;
};
export var TimePicker = connect({
    getValueFromEvent: function (_, value) {
        return transformMoment(value);
    },
    getProps: compose(mapStyledProps, mapMomentValue),
    getComponent: mapTextComponent,
})(AntdTimePicker);
TimePicker.RangePicker = connect({
    getValueFromEvent: function (_, _a) {
        var startDate = _a[0], endDate = _a[1];
        return [transformMoment(startDate), transformMoment(endDate)];
    },
    getProps: compose(mapStyledProps, mapMomentValue),
    getComponent: mapTextComponent,
})(AntdTimePicker.RangePicker);
export default TimePicker;
